import React,{ Component} from 'react';
import SeriesList from '../../Components/SeriesList';
import Loader from '../../Components/Loader';
import Intro from '../../Components/Intro';


class Series extends Component{

    state = {
        series: [],
        seriesName: '',
        isFetching: false
      }
      
   //   componentDidMount(){
     
    //  }
      
      onSeriesInputChange = e =>{
        this.setState({ seriesName: e.target.value, isFetching: true})

        fetch(`http://api.tvmaze.com/search/shows?q=${e.target.value}`)
        .then(response => response.json())
        .then(json => this.setState({series:json, isFetching: false}))
      }

    render(){
        const {series, seriesName, isFetching} = this.state;

        return (
            <div>The length of series array  - {this.state.series.length}
            <div><Intro message ="Here you can find all of your most loved series" /> 
          </div>
            <div>
                <input 
                value = {seriesName}
                type="text" 
                onChange={this.onSeriesInputChange}></input>
            </div>
            {
                !isFetching && series.length === 0 && seriesName.trim() === '' 
                &&
                <p>Please enter series name into the input</p>
            }
            {
                !isFetching && series.length === 0 && seriesName.trim() !== ''
                &&
                <p>No Series Name found with this name</p>
            }
            {
                isFetching && <Loader></Loader>
            }
            {
                !isFetching &&
            <SeriesList  list={this.state.series} ></SeriesList>
            }
            </div>
        )
    }

}

export default Series;